import styled from '@emotion/styled'

import { Link, NativeLink, palette } from 'main/ui'

export const StyledNativeLink = styled(NativeLink)`
  color: ${palette.slate};
  font-size: 14px;
`

export const StyledLink = StyledNativeLink.withComponent(Link)
